import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const hotVideos = videos.filter((v) => v.isHot);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            热门精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            本周最受欢迎的视频内容，精彩不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - 就要草视频`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {video.duration}
                </div>
                <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded">
                  热门
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors font-heading">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {video.description}
                </p>
                <div className="flex items-center justify-between text-xs text-secondary-500">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {video.views >= 10000
                        ? `${(video.views / 10000).toFixed(1)}万`
                        : video.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500"></i>
                      {video.rating}
                    </span>
                  </div>
                  <span>{video.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/dianying"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-100 text-secondary-700 text-sm font-medium rounded-lg hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多热门视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}